import React from "react";
import { Box, VStack, Heading, Text } from "@chakra-ui/react";

import { StepFrontend } from "@constants";
import { TimelineEvent } from "./TimelineEvent";
import { TimelineTypes } from "./timelineTypes";

type TimelineProps = {
  steps: StepFrontend[];
  item: TimelineTypes;
};

export function Timeline({ steps, item }: TimelineProps) {
  return (
    <VStack w="100%" alignItems="flex-start">
      <Heading as="h3" size="lg" marginTop="16px">
        Timeline
      </Heading>
      {steps.length > 0 ? (
        <VStack w="100%" gap="16px" alignItems="flex-start" position="relative">
          <Box
            position="absolute"
            top="7"
            bottom="0"
            left="20px"
            bg="primary.100"
            _dark={{ bg: "primary.200" }}
            width="5px"
            borderRadius="5px"
          />
          {steps
            .sort(
              (stepA, stepB) =>
                Number(stepB.timestamp) - Number(stepA.timestamp),
            )
            .map((step: StepFrontend) => (
              <TimelineEvent
                key={`${step.stepName}--${step.timestamp.toLocaleString()}`}
                step={step}
                item={item}
                isDefaultOpen={
                  typeof step.comments != "undefined" && step.comments != ""
                }
              />
            ))}
        </VStack>
      ) : (
        <Text>No timeline events have been registered for this {item}.</Text>
      )}
    </VStack>
  );
}
